<template>
    <div class="container" >
        <div class="row justify-content-between my-3">
            <div class="col-auto" v-if="currentUser!=null && userProfile!=null && userProfile.role=='admin'">
                <button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#schoolModal">
                    Сургууль нэмэх
                </button>
            </div>
        </div>
      <div class= "row" v-if="schools!=null && schools.length>0">
        <div class="col-12" v-for="(q, index) in schools" v-bind:key="q.id">
            <div class="card-deck">
                <div  class="card shadow-sm mb-4">
                    <div class="card-header py-3">
                        <div class="row justify-content-between">
                            <div class="col col-9">
                                <!-- <h4 class="m-0 font-weight-bold text-primary" @click="_goDetail(q.id)" style="cursor:pointer">{{index+1}}.  {{q.name}} ({{q.shortName}}) </h4> -->
                                <h4 class="m-0 font-weight-bold text-primary">
                                    <span v-if="schools.length>1">{{index+1}}.</span>
                                    {{q.name}} ({{q.shortName}}) </h4>
                            </div>
                            <div class="col col-md-auto" v-on:click.stop="_editSchool(q)">
                                <i class="fas fa-edit"></i>
                            </div>
                            <!-- <div class="col col-md-auto"  v-on:click.stop="_deleteSchool(q)">
                                <i class="fas fa-trash"></i>
                            </div> -->
                        </div>
                    </div>
                    <div class="card-body">
                        <p v-if="q.description!=null">{{q.description.substring(0,200)}}...</p>
                        <p v-else style="color:red">Энэ сургуулийн товч танилцуулга теxт xарагдана.</p>
                        
                    </div>  
                    <div class="card-footer">
                        <div class="row">
                            <div class="col col-md-6">
                                <!-- <button class="btn btn-lg btn-mygray mr-2 btn-sm" @click="$router.push({name:'ListOfLessons', params:{schoolId: q.id}})">ХичээлүүдXXX</button>  -->
                                <button class="btn btn-sm btn-mygray mr-2 btn-sm" @click="$router.push({name:'SLessonsAll2', params:{schoolId: q.id}})">Хичээлүүд</button> 
                                  
                                <!-- <button class="btn btn-lg btn-mygray mr-2 btn-sm" @click="$router.push({name:'SLessonsAll', params:{schoolId: q.id}})">Хичээлүүд2</button>  -->
                                <button class="btn btn-sm btn-mygray mr-2 btn-sm" @click="$router.push({name:'SDepartments', params:{schoolId: q.id}})">Ангиуд</button>  
                                <!-- <button class="btn btn-lg btn-mygray mr-2 btn-sm" @click="$router.push({name:'DLessonsGrid', params:{schoolId: q.id}})">Ачаалал</button> -->
                                <!-- <button class="btn btn-lg btn-mygray mr-2 btn-sm" @click="$router.push({name:'AllLessonTimeTable', params:{schoolId: q.id}})">Xичээлийн xуваарь</button>     -->

                                <button class="btn btn-sm btn-warning mr-2 btn-sm" @click="$router.push({name:'Teachers', params:{schoolId: q.id}})">Багш</button>
                                <button class="btn btn-sm btn-primary mr-2 btn-sm" @click="$router.push({name:'Students', params:{schoolId: q.id}})">Сурагч</button>
                                <button class="btn btn-sm btn-primary mr-2 btn-sm" @click="$router.push({name:'StudentsAnalyse', params:{schoolId: q.id}})">Сурагч шинжилгээ</button>

                                <!-- <button class="btn btn-lg btn-mygray mr-2 btn-sm" @click="$router.push({name:'TobeRemovedLessons', params:{schoolId: q.id}})">TobeRemovedLessons</button> -->
                        
                            </div>
                            <div class="col col-md-6 pull-right">
                               <div class="float-right">
                                    <button class=" btn  btn-lg btn-info mr-2 btn-sm" @click="$router.push({name:'SchoolCategory', params:{schoolId: q.id}})">Хичээлийн ангилал</button>
                                <button class="btn btn-lg btn-info mr-2 btn-sm" @click="$router.push({name:'Semester', params:{schoolId: q.id}})">Хичээлийн улирал</button>
                                <button class="btn btn-lg btn-danger mr-2 btn-sm" @click="$router.push({name:'SchoolSector', params:{schoolId: q.id}})">ЗАС </button>
                                <button class="btn btn-lg btn-info  btn-sm" @click="$router.push({name:'XNews', params:{schoolId: q.id}})">Мэдээ</button>
                                
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="schoolModal" tabindex="-1" role="dialog" aria-labelledby="schoolModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="schoolModalLabel">Сургууль нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form class="user">
                    <div class="form-group">
                        <label>Сургуулийн албан ёсны нэр</label>
                        <input v-model.trim="object.name" class="form-control" aria-describedby="emailHelp" placeholder="Бүрэлдэxүүн сургуулийн нэр">
                    </div>
                    <div class="form-group">
                        <label>Товчилсон нэр</label>
                        <input v-model.trim="object.shortName" class="form-control" aria-describedby="emailHelp" placeholder="Сургуулийн товчилсон нэр">
                    </div>
                    <div class="form-group">
                        <label>Сургуулийн товч танилцуулга</label>
                        <textarea rows="10" v-model.trim="object.description" class="form-control" id="exampleInputPassword" placeholder="Тайлбар мэдээлэл"/>
                    </div>

                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" v-model="object.university">
                        <label class="form-check-label">Их сургууль эсэх</label>
                    </div>
                    <hr>
                    
                </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="saveSchool" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
                schools:[],
                departments:[],
                object:{
                    name:'',
                    shortName:'',
                    description:'',
                    university:false

                },

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            _getQA(){
                if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
                    fb.db.collection("schools").onSnapshot(querySnapshot=> {
                        this.schools=[];
                        querySnapshot.forEach(doc=> {
                            let object=doc.data()
                            object.id = doc.id
                            this.schools.push(object);
                        });
                    });
                }
                else if(this.userProfile!=null && this.userProfile['role']!=null && (this.userProfile['role']=="sts" || this.userProfile['role']=="manager") && this.userProfile['customer']!=null){
                    this.userProfile['customer'].get().then(cusDoc=>{
                        if(cusDoc.exists && cusDoc.data().schools!=null){
                            for(const scRef of cusDoc.data().schools){
                                scRef.get().then(schoolData=>{
                                    let object=schoolData.data();
                                    object.id=schoolData.id;
                                    this.schools.push(object);
                                });
                            }
                        }
                    });
                }
                
            },
            _goQuestions(postId){
                this.$router.push({ name: 'Questions', params: { qaId: postId} })
            },
            _goDetail(schoolId){
                this.$router.push({ name: 'SchoolDetail', params: { schoolId: schoolId} })
            },
            saveSchool(){
                if(this.object!=null && this.object!=null && this.object.name!='' && this.object.description!=''){
                    if(this.object.id!=null && this.object.id!=''){
                        fb.db.collection("schools").doc(this.object.id).update({
                            'name':this.object.name,
                            'shortName':this.object.shortName,
                            'description':this.object.description,
                            'modifiedAt':new Date(),
                            'modifiedUser': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                            'university': this.object.university?this.object.university:false
                        })
                    }
                    else{
                        this.object.createdAt=new Date()
                        this.object.userId=this.$store.getters.currentUser.uid;
                        this.object.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        fb.db.collection("schools").doc().set(this.object);
                    }
                    this.object={
                        'name':null,
                        'shortName': null,
                        'description':null,
                        'university':false
                    }
                }
                else{
                    alert("Та сургуулийн нэр, тайлбараа оруулна уу");
                }
            },
            _editSchool(school){
                this.object= Object.assign({}, school);
                $('#schoolModal').modal('toggle');
            },
            _deleteSchool(school){
               var result = confirm("Та "+school.name+" сургуулийг устгах уу?");
                if (result) {
                    fb.db.collection("schools").doc(school.id).delete()
                }

            }
  
        },
        created() {
            this._getQA();
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
